import {Link} from '@mui/material';

import {PRIVACY_POLICY} from '../../constants/routes';

export default function PrivacyPolicy({children, ...props}) {
  return (
    <Link href={`/#${PRIVACY_POLICY}`} target="_blank" {...props}>
      {children || 'POLÍTICA DE PRIVACIDADE'}
    </Link>
  );
}
